module.exports = __webpack_public_path__ + "static/media/course-list.a0e84148.png";